import { withTranslation, WithTranslationProps } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { get } from 'lodash'
import { login, singleSignOn, sendForgotPasswordEmail } from './login.actions'
import LoginPage from './Login'
import { RootState } from '../app.reducer'
import { TenantSummary } from './login.api'

const mapStateToProps = ({ app }: RootState, { i18n }: WithTranslationProps) => {
  const { prerequisites } = app
  const version = prerequisites ? prerequisites.version : ''
  const fipsEnabled = prerequisites ? prerequisites.fipsEnabled : false
  const tenants = app.tenants.sort((a: TenantSummary, b: TenantSummary) => a.name.localeCompare(b.name)) || []
  const loginError = app.loginError || ''
  const singleSignOnError = app.singleSignOnError || ''
  const locale = i18n?.language
  const user = app.user
  const redirectDestination = get(app, 'redirectDestination')
  const forgotPasswordResult = app.forgotPasswordResult ? app.forgotPasswordResult : app.error

  return {
    version,
    fipsEnabled,
    tenants,
    loginError,
    singleSignOnError,
    locale,
    forgotPasswordResult,
    user,
    redirectDestination,
  }
}

const mapDispatchToProps = {
  onLogin: login,
  onSingleSignOn: singleSignOn,
  onConfirmForgotPassword: sendForgotPasswordEmail,
}

const mergeProps = (stateProps: $TSFIXME, dispatchProps: $TSFIXME, ownProps: $TSFIXME) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  onLogin: (username: string, password: string, tenant: TenantSummary) => dispatchProps.onLogin(username, password, tenant, stateProps.locale),
})

export default compose(withTranslation(), connect(mapStateToProps, mapDispatchToProps, mergeProps))(LoginPage)
